import React from 'react';
import { clsx } from 'clsx';
import Icon from 'components/icon/icon.component';
import { icons } from 'lucide-react';
import './stat-tile.style.scss';

export type StatTone = 'neutral' | 'positive' | 'warning' | 'critical';

interface IProps {
  /** ReactNode rather than string so a raw t() return can be passed through. */
  label: React.ReactNode;
  value: React.ReactNode;
  /** Secondary line, e.g. a percentage or a share of a total. */
  hint?: React.ReactNode;
  icon?: keyof typeof icons;
  tone?: StatTone;
}

const StatTile: React.FC<IProps> = ({ label, value, hint, icon, tone = 'neutral' }) => {
  return (
    <div className={clsx('statTile', `statTile--${tone}`)}>
      <div className="statTile__head">
        <span className="statTile__label">{label}</span>
        {icon && <Icon name={icon} size={16} />}
      </div>
      <div className="statTile__value">{value}</div>
      {hint !== undefined && hint !== null && <div className="statTile__hint">{hint}</div>}
    </div>
  );
};

export default StatTile;
